<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 재해예방 기술지도 정보 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 재해예방 기술지도</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div class="form-title">공사명</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.공사명" :max="300" :visible-counter="true" />
        </div>

        <div>
          <div class="form-title">공사업체</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.공사업체" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div class="form-title">공사금액(억원)</div>
          <number-input :readonly="board.readonly" :max="999999" :min="0" v-model="form.공사금액"  />
        </div>
        <div>
          <div class="form-title">지도기관/업체</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.지도기관업체" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div class="form-title">지도기간</div>
          <DateSelectorRang :readonly="board.readonly" :isPrint="isPrint" v-model="form.지도기간" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import NumberInput from "@/components/NumberInput.vue";

export default {
  components: {
    NumberInput,
    DateSelector,
    FileUploader,
    FileUploadModule,
    FieldSelectModule,
    DateSelectorRang,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        공사명: "",
        공사업체: "",
        공사금액: "",
        지도기관업체: "",
        지도기간: "",
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    // 이전 문서 불러오기
    this.$emit("setPrevBoardOptions", {
      boardId: 741,
      btnLabel: "비상대응조치계획 수립 불러오기",
      prevBoardSelectRow: (data) => {
        let postContent = data.post_content;
        if (postContent) {
          postContent = JSON.parse(postContent);
          console.log(postContent);
          const year = postContent.header.year;
          const body = postContent.body;

          this.header.year = year;
          this.form.stdInfo.field_address = body.stdInfo.field_address;
          this.form.stdInfo.field_id = body.stdInfo.field_id;
          this.form.stdInfo.field_name = body.stdInfo.field_name;
          this.form.시나리오명 = body.시나리오명;
          this.form.관리부서 = body.관리부서;
        }
      },
    });
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
